import { ProductivityDashboardItemSchema } from "@redotech/redo-model/outbound-labels/productivity-dashboard";
import { z } from "zod";

export const getProductivityDashboardData = {
  input: z.object({
    search: z.string().nullish(),
    filters: z.record(z.string(), z.string()),
    sort: z
      .object({ key: z.string(), direction: z.enum(["asc", "desc"]) })
      .nullish(),
  }),
  output: z.object({ data: z.array(ProductivityDashboardItemSchema) }),
};
